// extracted by mini-css-extract-plugin
export default {"divInput":"style_divInput__D9Efj","labelInput":"style_labelInput__sIaJ6","input":"style_input__zp30j"};